<int-integrators-details
        [integrationName]="integrationName"
        [integrationType]="integrationType"
        [creating]="creating"
        [user]="user"
        [invites]="invites"></int-integrators-details>

<div mat-dialog-content>
    <div *ngIf="isAdmin && !creating && existingIntegrations.length > 0 && invites.length > 0">
        <button mat-stroked-button color="primary" (click)="onViewInvitesClick()">VIEW ALL INVITES</button>
    </div>
    <div *ngIf="!creating" fxLayout="row" fxLayoutAlign="start center">
        <h4 *ngIf="existingIntegrations.length > 0" class="mr-4">Connected Buckets</h4>
        <button mat-stroked-button color="primary" (click)="addAnother($event)">
            Add S3
        </button>
    </div>

    <div *ngIf="!creating">
        <div *ngFor="let int of existingIntegrations">
            Bucket name: {{ int.bucketName || int.bucketArn.split(':')[int.bucketArn.split(':').length - 1] }}
        </div>
    </div>

    <div *ngIf="creating">
        <p class="text-container">
            There are three ways to access S3 accounts, depending on privacy and account concerns. The easiest one,
            which we recommend for most users, is by inputting an access key below.
        </p>
    </div>
    <div *ngIf="creating">
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="center center">
                <div class="number-icon" fxLayoutAlign="center center">1</div>
                <div mat-dialog-title style="margin: 0;">Access Keys (Recommended)</div>
            </div>
            <button mat-icon-button (click)="toggleCollapse(1)">
                <mat-icon>{{ status === 1 ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
        </div>
        <div [fxShow]="status === 1">
            <div fxLayout="row" fxLayoutAlign="start center">
                <p class="text-container">
                    Enter you AWS IAM credentials below. We recommend creating a new IAM user for Advocado with programmatic
                    access only. There is no need to grant access to the management console. Advocado recommends creating a custom
                    policy for the user with the following permissions:
                </p>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <ul class="int-text-container" style="list-style-type: none; padding-left: 0;">
                    <li>s3:ListBucket</li>
                    <li>s3:GetObject</li>
                    <li>s3:DeleteObject</li>
                    <li>s3:PutObject</li>
                </ul>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <p class="text-container">
                    We recommend adding the ARNs for any buckets you would like to connect to the resources section of the policy.
                    Please contact <a href="mailto:technical@myadvocado.com" target="_blank">technical@myadvocado.com</a>
                    if you need help configuring your S3 data destination.
                </p>
            </div>
            <form [formGroup]="form1" class="icon-buffer">
                <div fxLayout="row">
                    <mat-form-field appearance="outline">
                        <mat-label>Friendly Name *</mat-label>
                        <input matInput name="friendlyName" formControlName="friendlyName" />
                        <mat-error *ngIf="form1.controls.friendlyName.errors">
                            Friendly name is required.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row">
                    <mat-form-field appearance="outline">
                        <mat-label>Access Key ID *</mat-label>
                        <input matInput name="accessKeyId" formControlName="accessKeyId" />
                        <mat-error *ngIf="form1.controls.accessKeyId.errors">
                            Access Key ID is required.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row">
                    <mat-form-field appearance="outline">
                        <mat-label>Secret Access Key *</mat-label>
                        <input matInput name="secretAccessKey" formControlName="secretAccessKey" />
                        <mat-error *ngIf="form1.controls.secretAccessKey.errors">
                            Secret Access Key is required.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row">
                    <mat-form-field appearance="outline">
                        <mat-label>Region *</mat-label>
                        <input matInput name="region" formControlName="region" />
                        <mat-error *ngIf="form1.controls.region.errors">
                            Region is required.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row">
                    <mat-form-field appearance="outline">
                        <mat-label>Bucket Name *</mat-label>
                        <input matInput name="bucketName" formControlName="bucketName" />
                        <mat-error *ngIf="form1.controls.bucketName.errors">
                            Bucket Name is required.
                        </mat-error>
                    </mat-form-field>
                </div>
            </form>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" class="vertical-margin">
            <div class="hr-side"></div>
            <div mat-dialog-title class="hr-center">OR</div>
            <div class="hr-side"></div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="center center">
                <div class="number-icon" fxLayoutAlign="center center">2</div>
                <div mat-dialog-title style="margin: 0;">Cross Account Bucket Policy</div>
            </div>
            <button mat-icon-button (click)="toggleCollapse(2)">
                <mat-icon>{{ status === 2 ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
        </div>
        <div [fxShow]="status === 2">
            <div fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="icon-style">view_quilt</mat-icon>
                <p class="text-container">
                    Create a bucket for Advocado in your AWS account, filling out your Amazon Bucket ARN details below.
                </p>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <form [formGroup]="form2" class="icon-buffer">
                    <mat-form-field appearance="outline">
                        <mat-label>Amazon Bucket ARN *</mat-label>
                        <input matInput name="bucketArn" formControlName="bucketArn" />
                        <mat-error *ngIf="form2.controls.bucketArn.errors">
                            Amazon Bucket ARN is required.
                        </mat-error>
                    </mat-form-field>
                </form>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="icon-style">edit</mat-icon>
                <p class="text-container">
                    Next, edit the bucket policy to include Advocado's Role ARN as the Principal, copying the Advocado Account
                    ID with the below permissions.
                </p>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="icon-style">content_copy</mat-icon>
                <p class="text-container">
                    arn:aws:iam::737238977145:role/advocado-external-s3
                </p>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <button mat-stroked-button color="primary" class="int-manage-btn icon-buffer" (click)="copyToClipboard(ROLE_ARN)">
                    <mat-icon style="color: #0f62fe;">content_copy</mat-icon>
                    COPY ADVOCADO ROLE ARN
                </button>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <ul class="int-text-container" style="list-style-type: none;">
                    <li><strong>Permissions:</strong></li>
                    <li>s3:ListBucket</li>
                    <li>s3:GetObject</li>
                    <li>s3:DeleteObject</li>
                    <li>s3:PutObject</li>
                </ul>
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" class="vertical-margin">
            <div class="hr-side"></div>
            <div mat-dialog-title class="hr-center">OR</div>
            <div class="hr-side"></div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="center center">
                <div class="number-icon" fxLayoutAlign="center center">3</div>
                <div mat-dialog-title style="margin: 0;">Cross Account Role</div>
            </div>
            <button mat-icon-button (click)="toggleCollapse(3)">
                <mat-icon>{{ status === 3 ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
        </div>
        <div [fxShow]="status === 3">
            <div fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="icon-style">view_quilt</mat-icon>
                <p class="text-container">
                    Create a bucket for Advocado in your AWS account, filling out your Amazon Bucket ARN details below.
                </p>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <form [formGroup]="form3" class="icon-buffer">
                    <mat-form-field appearance="outline">
                        <mat-label>Amazon Bucket ARN *</mat-label>
                        <input matInput name="bucketArn" formControlName="bucketArn" />
                        <mat-error *ngIf="form3.controls.bucketArn.errors">
                            Amazon Bucket ARN is required.
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Amazon Role ARN *</mat-label>
                        <input matInput name="roleArn" formControlName="roleArn" />
                        <mat-error *ngIf="form3.controls.roleArn.errors">
                            Amazon Role ARN is required.
                        </mat-error>
                    </mat-form-field>
                </form>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <p class="text-container icon-buffer">
                    After that, copy Advocado's account id below, then create a role in your account with permissions granted
                    to the Advocado id. Advocado will then access S3 from the external account.
                </p>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="icon-style">content_copy</mat-icon>
                <p class="text-container">
                    737238977145:role/advocado-external-s3
                </p>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <button mat-stroked-button color="primary" class="int-manage-btn icon-buffer" (click)="copyToClipboard(ACCOUNT_ID)">
                    <mat-icon style="color: #0f62fe;">content_copy</mat-icon>
                    COPY ADVOCADO ACCOUNT ID
                </button>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <ul class="int-text-container" style="list-style-type: none;">
                    <li><strong>Permissions:</strong></li>
                    <li>s3:ListBucket</li>
                    <li>s3:GetObject</li>
                    <li>s3:DeleteObject</li>
                    <li>s3:PutObject</li>
                </ul>
            </div>
        </div>
        <div *ngIf="status !== 0" fxLayout="row" fxLayoutAlign="end center">
            <button mat-button color="primary" mat-dialog-close>CANCEL</button>
            <button
                    mat-raised-button
                    color="primary"
                    [disabled]="submitDisabled()"
                    (click)="create($event)"
                    [appShowSpinner]="loading"
                    [buttonText]="'SAVE'"></button>
        </div>
    </div>
</div>
<div *ngIf="!creating" align="end">
    <button mat-button mat-dialog-close>CANCEL</button>
</div>